import React, { useState } from 'react'
import { Button } from 'reactstrap'

const ConsultBanner = (props) => {

    const bookConsult = () => {
        window.open ('https://scheduler.zoom.us/investment-expert/book-consultation', '_blank')
    }

  return (
        <div className='consult-banner'>
            <p>Book a free consultation with our Expert.</p>
            <Button onClick={bookConsult} outline className='book'>Book Now</Button>
            <span onClick={props.closeConsultBanner} className="mdi mdi-close-circle" style={{color: "#FFFFFF"}}></span>
        </div>
  )
}

export default ConsultBanner